export const INITILIZE_STATE_ERROR = 'INITILIZE_STATE_ERROR';
export const GET_USER_PROFILE_ERROR = 'GET_USER_PROFILE_ERROR';
export const GET_USER_PROFILE_PENDING = 'GET_USER_PROFILE_PENDING';
export const GET_USER_PROFILE_FULFILLED = 'GET_USER_PROFILE_FULFILLED';
export const UPDATE_USER_PROFILE_PENDING = 'UPDATE_USER_PROFILE_PENDING';
export const UPDATE_USER_PROFILE_FULFILLED = 'UPDATE_USER_PROFILE_FULFILLED';
export const UPDATE_USER_PROFILE_ERROR = 'UPDATE_USER_PROFILE_ERROR';
export const UPDATE_USER_ADDRESS_PENDING = 'UPDATE_USER_ADDRESS_PENDING';
export const UPDATE_USER_ADDRESS_FULFILLED = 'UPDATE_USER_ADDRESS_FULFILLED';
export const UPDATE_USER_ADDRESS_ERROR = 'UPDATE_USER_ADDRESS_ERROR';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT_FULFILLED = 'LOGOUT_FULFILLED';
export const LOGOUT_LOADING = 'LOGOUT_LOADING';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_PENDING = 'FORGOT_PASSWORD_PENDING';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_PENDING = 'RESET_PASSWORD_PENDING';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_PENDING = 'SIGN_UP_PENDING';
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR';
export const SHOW_LOGIN = 'SHOW_LOGIN';

export const ADD_USER_EMAIL_FULFILLED = 'ADD_USER_EMAIL_FULFILLED';
export const ADD_USER_EMAIL_PENDING = 'ADD_USER_EMAIL_PENDING';
export const ADD_USER_EMAIL_ERROR = 'ADD_USER_EMAIL_ERROR';

export const SET_AUDKENNI_VERIFICATION_CODE = 'SET_AUDKENNI_VERIFICATION_CODE';